export default {
  name: 'transaction_customer_gender',
  component_path: 'modules/procedures/blocks/BlockInputSelect'
}